import { usersApi } from 'entities/users';

const getDirections = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    getDirections: builder.query({
      query: () => '/news-pages/admin/directions/',
    }),
  }),
});

export const { useGetDirectionsQuery } = getDirections;
